import { addDays, parseISO, isBefore, isEqual } from 'date-fns';
import { pedido } from './Constants';

const {
    numPedido,
    minutos,
    quantidade,
    periodoPlan,
    listaCritica,
    node,
    dataCriacao,
    cNotaQM,
    cStatusQM,
    cDataQM,
    statusAud,
    dataAud,
    obsAud,
    opSeg,
    cor,
    tipoMaterial,
    fornecedor,
    nota5903,
    minutos5903,
    pecas5903,
    descCota,
    dtPrecon,
    status,
    dataEstatistica: data_estatistica,
} = pedido;

export const convertNumber = (value, index = 0) => {
    let format = Number(value).toFixed(index);
    return Number(format).toLocaleString('pt-BR');
};

export const calculaDiasSemana = (dataAtual = new Date()) => {
    let curr = new Date(parseISO(dataAtual)); // get current date
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    let firstDayWeek = new Date(curr.setDate(first));

    let dates = [];
    for (let i = 1; i <= 7; i++) {
        let day = addDays(firstDayWeek, i);
        // checa se dia é 0 (domingo) ou 6 (sábado)
        if (day.getDay() > 0 && day.getDay() < 6) dates.push(day);
    }
    //dates.push(addDays(dates[4], 3));
    return dates;
};

export const groupByType = result => {
    /** GROUP BY FUNCTION */

    //Adiciona pedidoCor para fazer o agrupamento de mais pedidos do mesmo material com a mesma cor
    const concat = result.map(e => {
        return {
            ...e,
            pedidoCor: e.EBELN + '|' + e.COR,
        };
    });

    const groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
            const value = obj[key];
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {});

    const groupByMaterial = groupBy('MATNR_ACABADO');
    const groupByPedidoCor = groupBy('pedidoCor');

    let group = groupByMaterial(concat);
    const keys = Object.keys(group);
    let final = [];

    for (let i = 0; i < Object.keys(group).length; i++) {
        final.push({
            material: keys[i],
            pedidoCor: {
                ...groupByPedidoCor(group[keys[i]]),
            },
        });
    }

    let sum = [];
    final.map(e =>
        Object.keys(e.pedidoCor).forEach(d => {
            let time = 0;
            let pieces = 0;
            let pv = '';
            let pedido = '';
            let critica = '';
            let no = '';
            let dataSaida = '';
            let dataQM = '';
            let statusQM = '';
            let notaQM = '';
            let statusAuditoria = '';
            let dataAuditoria = '';
            let obsAuditoria = '';
            let opSeguinte = '';
            let tMaterial = '';
            let color = '';
            let forn = '';
            let not5903 = '';
            let qtd5903 = 0;
            let qtdPecas5903 = 0;
            let cota = '';
            let dataEstatistica;
            let previsaoGerfac = '';
            let statusGerfac = '';

            for (let i = 0; i < e.pedidoCor[d].length; i++) {
                dataEstatistica = e.pedidoCor[d][i][data_estatistica];
                time += e.pedidoCor[d][i][minutos] || 0;
                pieces += e.pedidoCor[d][i][quantidade];
                pv = e.pedidoCor[d][i][periodoPlan];
                pedido = e.pedidoCor[d][i][numPedido];
                critica = e.pedidoCor[d][i][listaCritica];
                no = e.pedidoCor[d][i][node];
                dataSaida = e.pedidoCor[d][i][dataCriacao];
                dataQM = e.pedidoCor[d][i][cDataQM];
                statusQM = e.pedidoCor[d][i][cStatusQM];
                previsaoGerfac = e.pedidoCor[d][i][dtPrecon];
                statusGerfac = e.pedidoCor[d][i][status];
                notaQM = e.pedidoCor[d][i][cNotaQM];
                statusAuditoria = e.pedidoCor[d][i][statusAud];
                dataAuditoria = e.pedidoCor[d][i][dataAud];
                obsAuditoria = e.pedidoCor[d][i][obsAud];
                opSeguinte = e.pedidoCor[d][i][opSeg];
                color = e.pedidoCor[d][i][cor];
                tMaterial = e.pedidoCor[d][i][tipoMaterial];
                forn = e.pedidoCor[d][i][fornecedor];
                qtd5903 = e.pedidoCor[d][i][minutos5903] || 0;
                qtdPecas5903 = e.pedidoCor[d][i][pecas5903] || 0;
                not5903 = e.pedidoCor[d][i][nota5903];
                cota = e.pedidoCor[d][i][descCota];
            }
            sum.push({
                dataEstatistica,
                pedido: pedido,
                material: e.material,
                tipoMaterial: tMaterial,
                cor: color,
                pecas: pieces,
                minutos: time.toFixed(3),
                no,
                pv,
                critica,
                dataSaida,
                dataQM,
                statusQM,
                notaQM,
                statusAuditoria,
                dataAuditoria,
                obsAuditoria,
                opSeguinte,
                fornecedor: forn,
                qtd5903,
                not5903,
                qtdPecas5903,
                cota,
                previsaoGerfac,
                statusGerfac,
            });
        })
    );
    return sum;
};

export const capitalizeFLetter = string => {
    return string[0].toUpperCase() + string.slice(1);
};

export const compareDates = (a, b) => {
    if (isBefore(parseISO(a.data), parseISO(b.data))) return 1;
    if (isBefore(parseISO(b.data), parseISO(a.data))) return -1;
    if (isEqual(parseISO(a.data), parseISO(b.data))) return 0;
};

export const ordenarPorAlfabetica = (a, b) => {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
};

export const loadSituacaoGerfac = status => {
    switch (status) {
        case '5':
            return '5 - Programada';
        case '10':
            return '10 -Enviada';
        case '15':
            return '15 - Recebida';
        case '20':
            return '20 - Iniciada';
        case '30':
            return '30 - Concluída';
        case '40':
            return '40 - Retornada';
        case '50':
            return '50 - Lib. Qualidade';
        case '90':
            return '90 - Finalizada';
        case '99':
            return '99 - Cancelada';
        default:
            return status;
    }
};
